import {PlusOutlined} from "@ant-design/icons";
import {ConfigProvider, Image, Upload} from "antd";
import React, {useState} from "react";
import Cookies from "js-cookie";

// helper method to retrieve file
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const WorkForceCaseImageCreateUploadComponent = ({onChange, value}) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState(value ?? []);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };


    const handleChange = ({file, fileList: newFileList}) => {
        if(file?.status !== "uploading") {
            onChange(newFileList);
        }
        setFileList(newFileList);
    }


    const handleRemove = (data) => {
        const index = fileList.indexOf(data);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        onChange(newFileList);
    }


    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button"
        >
            <PlusOutlined/>
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    return (
        <>
            <div className="py-3">
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "blue",
                            borderRadius: 5,
                        },
                    }}
                >
                    <Upload
                        name={"files"}
                        action={`${process.env.REACT_APP_API_BASE_URL}/File/upload-file`}
                        headers={{authorization: `Bearer ${Cookies.get("jwtToken")}`}}
                        listType="picture-card"
                        fileList={fileList}
                        multiple={true}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        onRemove={handleRemove}
                        maxCount={3}
                    >
                        {fileList.length >= 3 ? null : uploadButton}
                    </Upload>
                    {previewImage && (
                        <Image
                            wrapperStyle={{
                                display: "none",
                            }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(""),
                            }}
                            src={previewImage}
                        />
                    )}
                </ConfigProvider>
            </div>
        </>
    );
};

export default WorkForceCaseImageCreateUploadComponent;
